import styled from 'styled-components';

import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import { useLanguage } from '../../../Context/LanguageContext';

import LockerDivisionInput from '../../../Component/LockerComponent/LockerDivisionInput';
import PointerReorderItem from '../../Share/Normal/PointerReorderItem';

import { ReactComponent as PlusSvg } from '../../../image/Plus.svg';
import { ReactComponent as DeleteSvg } from '../../../image/Delete.svg';
import { ReactComponent as MenuSvg } from '../../../image/Menu3.svg';

export default function LockerDivisionList(props) {
  const {
    reorder,
    isClickedLockerDivisionId,
    setIsClickedLockerDivisionId,
    totalLockers,
    lockerDivisions,
    divisionNameDraft,
    onClickDivisionDeleteIcon,
    isClickedAddLockerDivision,
    newLockerName,
    setNewLockerName,
    onCancelAddDivision,
    onClickLockerDivisionAddButton,
    isEditMode
  } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

  return (
    <DivisionButtonsGroup ref={reorder.containerRef}>
      <LockerDivisionButton
        isClicked={isClickedLockerDivisionId === 0}
        onClick={() => setIsClickedLockerDivisionId(0)}>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={isClickedLockerDivisionId === 0 ? theme.background : theme.subText} hover='pointer'>{t('main.locker.all')}</Text>
      </LockerDivisionButton>
      {
        (totalLockers.find(d => d.id === -1)?.lockers.length ?? 0) > 0 &&
        <PointerReorderItem reorder={reorder} index={-1}>
          <LockerDivisionButton
            isClicked={isClickedLockerDivisionId === -1}
            onClick={() => setIsClickedLockerDivisionId(-1)}>
            <LockerDivisionButtonLeftWrapper>
              {
                isClickedLockerDivisionId === -1 &&
                <DivisionMenuIcon
                  onPointerDown={(e) => reorder.onPointerDown(e, -1)}
                  onContextMenu={(e) => e.preventDefault()} />
              }
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={isClickedLockerDivisionId === -1 ? theme.background : theme.subText} hover='pointer'>{t('main.locker.other')}</Text>
            </LockerDivisionButtonLeftWrapper>
            {
              isClickedLockerDivisionId === -1 &&
              <DivisionDeleteIcon
                data-delete-icon
                onClick={onClickDivisionDeleteIcon} />
            }
          </LockerDivisionButton>
        </PointerReorderItem>
      }
      {
        lockerDivisions.slice(1).map((data, index) => (
          <PointerReorderItem key={data.id} reorder={reorder} index={index}>
            <LockerDivisionButton
              isClicked={isClickedLockerDivisionId === data.id}
              onClick={() => setIsClickedLockerDivisionId(data.id)}>
              <LockerDivisionButtonLeftWrapper>
                {
                  isClickedLockerDivisionId === data.id &&
                  <DivisionMenuIcon
                    onPointerDown={(e) => reorder.onPointerDown(e, index)}
                    onContextMenu={(e) => e.preventDefault()} />
                }
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={isClickedLockerDivisionId === data.id ? theme.background : theme.subText} hover='pointer'>{divisionNameDraft[data.id] ?? data.name}</Text>
              </LockerDivisionButtonLeftWrapper>
              {
                isClickedLockerDivisionId === data.id &&
                <DivisionDeleteIcon
                  data-delete-icon
                  onClick={onClickDivisionDeleteIcon} />
              }
            </LockerDivisionButton>
          </PointerReorderItem>
        ))
      }
      {
        isClickedAddLockerDivision &&
        <LockerDivisionInput
          value={newLockerName}
          setValue={setNewLockerName}
          onCancel={onCancelAddDivision} />
      }
      {
        !isEditMode &&
        <LockerAdditionButton data-locker-add-button isClicked={isClickedAddLockerDivision} onClick={onClickLockerDivisionAddButton}>
          {
            isClickedAddLockerDivision ?
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subBackground} hover='pointer'>{t('main.locker.addDivision')}</Text>
              :
              <PlusIcon />
          }
        </LockerAdditionButton>
      }
    </DivisionButtonsGroup>
  );
}

const DivisionButtonsGroup = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  align-items: center;

  flex: 1;
  max-width: calc(100% - 59px);

  gap: 10px;
`;

const LockerDivisionButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 5px 12px;
  gap: 20px;

  box-sizing: border-box;
  max-width: 300px;
  height: 30px;

  border-radius: 5px;
  background-color: ${props => props.isClicked ? props.theme.primary : props.theme.buttonFill};

  /* 모바일 long-press 시 텍스트 선택/복사 콜아웃 차단 */
  user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: transparent;

  /* Android Chrome 은 부모 user-select 상속을 가끔 무시해서 자식에도 명시 */
  * {
    user-select: none;
    -webkit-user-select: none;
    -webkit-touch-callout: none;
  }

  &:has([data-delete-icon]:hover) {
    background-color: ${props => props.theme.pointRed};
  }

  &:hover {
    cursor: pointer;
  }

  transition:
    background-color 0.25s ease-in-out,
    color 0.25s ease-in-out;
`;

const LockerAdditionButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 54.1px;
  height: 30px;

  flex-shrink: 0;

  border-radius: 5px;
  background-color: ${props => props.isClicked ? props.theme.primary : props.theme.buttonFill3};

  &:hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const PlusIcon = styled(PlusSvg)`
  flex-shrink: 0;
  width: 20px;
  height: 20px;

  color: ${props => props.theme.white};
`;

const LockerDivisionButtonLeftWrapper = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  gap: 10px;
  min-width: 0;
  overflow: hidden;
`;

const DivisionMenuIcon = styled(MenuSvg)`
  flex-shrink: 0;
  width: 10px;
  height: 10px;

  cursor: grab;
  touch-action: none;

  &:active {
    cursor: grabbing;
  }

  & rect {
    fill: ${props => props.theme.background};
  }
`;

const DivisionDeleteIcon = styled(DeleteSvg)`
  flex-shrink: 0;

  width: 18px;
  height: 18px;

  color: ${props => props.theme.background};

  transition: all 0.3s ease-in-out;

  @media (hover: hover){
    &:hover {
      cursor: pointer;
    }
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: 0;

  user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;

  &:hover {
    cursor: ${props => props.hover};
  }

  transition: all 0.3s ease-in-out;
`;
